const en = {
  send_a_message_to_the_acadly_team: 'Send a message to the acadly team',
  click_to_submit_feedback: 'click to submit feedback',
};

export default en;
